import { detailsBigCss, detailsSmallCss } from "@/styles/typography";
import styled from "styled-components";

const Form = styled.div<{ backgroundColor: string }>`
  .hubspot-form {
    width: 100%;

    fieldset {
      max-width: 100%;
      width: 100%;
    }

    input, select {
      width: 100% !important;
    }

    @media ${({ theme }) => theme.breakpoints.md} {
      width: 100%;
    }
  }

  .hs-fieldtype-text,
  .hs-fieldtype-select,
  .hs-fieldtype-textarea {
    ${detailsSmallCss}
    color: ${({ theme, backgroundColor }) =>
      backgroundColor === "white"
        ? theme.colors.primary
        : theme.textColors.secondary};
  }
  input[type="text"],
  [type="email"] {
    border: none;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    width: 100%;

    padding: 12px;
    margin-bottom: 4px;
  }

  input[type="checkbox"] {
    border: 2px solid ${({ theme }) => theme.colors.primary} !important;
    border-radius: 0 !important;
  }

  .input > select {
    background-color: white;
    padding: 12px;
    padding-bottom: 10px;
    margin-top: 10px;
    border-radius: 0;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    ${detailsSmallCss}
    color: ${({ theme }) => theme.colors.primary};
    height: 41px;
  }

  div.input {
    margin-top: 10px;
  }

  .field {
    margin-bottom: 16px;
  }

  .input > textarea {
    border: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: 0;
    padding: 12px;
    width: 100%;
    min-height: 250px;
    max-height: 500px;
    max-width: 100%;
    min-width: 100%;
  }

  .hs-form-booleancheckbox-display {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
  }

  .hs-form-booleancheckbox {
    list-style: none;
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;

    ${detailsSmallCss}
  }

  .hs-richtext {
    ${detailsSmallCss}
    color: ${({ theme }) => theme.colors.primary};
    gap: 10px;
  }

  input[type="submit"] {
    appearance: none;
    padding: 20px 48px 16px 48px;
    float: right;
    margin: 20px 0;
    border: 2px solid
      ${({ theme, backgroundColor }) =>
        backgroundColor === "white"
          ? theme.colors.primary
          : theme.textColors.secondary};
    border-radius: 0 !important;
    background-color: ${({ theme, backgroundColor }) =>
      backgroundColor === "white" ? theme.colors.primary : "transparent"};
    color: ${({ theme }) => theme.textColors.secondary};
    text-transform: uppercase;
    ${detailsBigCss}
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    input[type="submit"] {
      width: 100%;
    }
  }
  @media ${({ theme }) => theme.breakpoints.hover} {
    input[type="submit"]:hover {
      background-color: ${({ theme }) => theme.textColors.secondary};
      color: ${({ theme, backgroundColor }) =>
        backgroundColor === "white" || backgroundColor === "blue"
          ? theme.colors.primary
          : theme.colors.secondary};
    }
  }

  .hs-error-msgs {
    margin-top: 5px;
  }

  .hs-error-msg,
  .hs-main-font-element {
    color: #892121;
  }

  .hs-main-font-element {
    ${detailsSmallCss}
  }

  li {
    list-style: none;
  }
`;

const S = {
  Form,
};

export default S;
